import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-asset-audit-info',
  templateUrl: './asset-audit-info.component.html',
  styleUrls: ['./asset-audit-info.component.css']
})
export class AssetAuditInfoComponent implements OnInit {


  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  assetAuditInfoList: any = []
  singleAssetData: any = []
  isLoading: any = false
  financialYear: any = ""
  isVerify: any = false
  yearList: any = []
  userCred: any = []
  file: any 
  auditList: any = [];
  objectInfoList: any = [];
  objectInfoSelectedList: any = [];
  objectInfoDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'objectInfoId',
    textField: 'givenName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  assetCurrentImages: any = []
  remarks: any = ""
  isAudit: any = "All"
  audit: any[] = [
    { key: 'All', value: "All" },
    { key: 'Verified', value: "true" },
    { key: 'Not Verified', value: "false" }
  ];

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);

    this.financialYear = new Date().getFullYear();
    this.generateYearList(2020,this.financialYear)

    this.getAllObjectInfo()
    this.getAllAssetAuditInfoByFinancialYear()

  }

  getAllObjectInfo(){
    this.generic_service.getAllObjectInfo().subscribe(
      (response:any)=>{
        console.log(response);
        this.objectInfoList = response.response
      },
      (error:any)=>{
        this.isLoading = false
        console.log(error)
      }
    )
  }

  removeAudit(objectInfoId: any) {
    // Remove from auditList
    this.auditList = this.auditList.filter((item: any) => item.objectInfoId !== objectInfoId);

    // Remove from selected list in multiselect dropdown
    this.objectInfoSelectedList = this.objectInfoSelectedList.filter((item: any) => item.objectInfoId !== objectInfoId);
  }

  onItemSelect(item: any) {
    console.log(item);
    for(let list of this.objectInfoList){
      if(list.objectInfoId == item.objectInfoId){
        this.auditList.push(list)
      }
    }

    console.log(this.auditList)
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  generateYearList(fromYear: number, toYear: number): void {
    this.yearList = [];

    for (let year = fromYear; year <= toYear; year++) {
      this.yearList.push({ year });
    }

    console.log(this.yearList)
    this.cid = Number(sessionStorage.getItem('cid'))

  }

  onTableDataChange(event: any) {
    console.log(event)
    this.page = event.page+1;
  }

  getAssetAuditInfoByAudited(){
    if(this.isAudit == "All"){
      this.getAllAssetAuditInfoByFinancialYear()
    }else {
    if(this.isAudit == "true" || this.isAudit == "false"){
        this.generic_service.getAssetAuditInfoByAudited(this.isAudit,this.financialYear).subscribe(
          (response: any)=>{
            console.log(response);
            if(response.response && response.response.length != 0){
              for(let list of response.response[0].financialYear.dataDateWise){
                list.assetAuditInfoId = response.response[0].assetAuditInfoId
                list.year = response.response[0].year
              }
            }
            this.assetAuditInfoList = []
            this.assetAuditInfoList = response.response[0]?.financialYear?.dataDateWise || []
            this.count = response.response[0]?.financialYear?.dataDateWise.length || 0
          },
          (error: any)=>{
            console.log(error)
          }
        )
      }
    }

  }

  getAllAssetAuditInfoByFinancialYear(){
    this.isAudit = "All"
    this.generic_service.getAllAssetAuditInfoByFinancialYear(this.financialYear).subscribe(
      (response: any)=>{
        console.log(response);
        if(response.response && response.response.length != 0){
          for(let list of response.response[0].financialYear.dataDateWise){
            list.assetAuditInfoId = response.response[0].assetAuditInfoId
            list.year = response.response[0].year
            list.isVerified = false
          }
        }
        this.assetAuditInfoList = []
        this.assetAuditInfoList = response.response[0]?.financialYear?.dataDateWise || []
        this.count = response.response[0]?.financialYear?.dataDateWise.length || 0
      },
      (error: any)=>{
        console.log(error)
      }
    )
  }

  clearData(){
    this.auditList = []
    this.objectInfoSelectedList = []
    this.remarks = ""
  }

  getSingleAssetAudit(asset: any){
    this.assetCurrentImages = []
    this.isVerify = false
    this.singleAssetData = []
    this.assetCurrentImages = asset.assetCurrentImages || []

    this.singleAssetData.push(asset)
    console.log(this.singleAssetData)
  }

  addAssetAuditInfo(){

    if(this.assetAuditInfoList.length != 0){
      return
    }


    let dataDateWise: any =  []

    for(let list of this.objectInfoList){
      let obj = {
        "version": 0,
        "isActive": true,
        "description": list.description,
        "assetId":  list.objectInfoId,
        "assetName":  list.givenName,
        "assetPurchaseValue": "",
        "assetCurrentEstimatedValue": "",
        "assetCondition":  list.objectCondition,
        "assetVerificationOn": "",
        "assetVerificationByUser": "",
        "assetVerificationByUserQualification": "",
        "assetVerificationByCompany": "",
        "audited": false,
        "remarks": "",
        "assetOldImages":  list.images,
        "assetCurrentImages": []
      }

      dataDateWise.push(obj)
    }

    console.log(dataDateWise)


    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "financialYear": {
        "version": 0,
        "isActive": true,
        "description": "",
        "dataDateWise": dataDateWise
      },
      "year": this.financialYear,
      "cid": this.cid
    }


    this.generic_service.addAssetAuditInfo(body).subscribe(
      (response:any)=>{
        console.log(response);
        this.auditList = []
        this.objectInfoSelectedList = []
        document.getElementById("closeModalAdd")?.click()
        this.toastr.success(response.message);
        this.getAllAssetAuditInfoByFinancialYear()

      },
      (error:any)=>{
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
      }
    )

  }


  verifyAsset(){
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "updatedData": {
        "version": 0,
        "isActive": true,
        "description": this.singleAssetData[0].description,
        "assetId": this.singleAssetData[0].assetId,
        "assetName": this.singleAssetData[0].assetName,
        "assetPurchaseValue": this.singleAssetData[0].assetPurchaseValue,
        "assetCurrentEstimatedValue": this.singleAssetData[0].assetCurrentEstimatedValue,
        "assetCondition": this.singleAssetData[0].assetCondition,
        "assetVerificationOn": formatDate(new Date(), 'dd-MM-yyyy', 'en-US'),
        "assetVerificationByUser": this.userCred.userName,
        "assetVerificationByUserQualification": this.singleAssetData[0].assetVerificationByUserQualification,
        "assetVerificationByCompany": this.singleAssetData[0].assetVerificationByCompany,
        "assetOldImages": this.singleAssetData[0].assetOldImages,
        "assetCurrentImages": this.assetCurrentImages,
        "remarks": this.remarks || this.singleAssetData[0].remarks,
        "audited": true,
      },
      "cid": this.cid,
      "assetAuditInfoId": this.singleAssetData[0].assetAuditInfoId
    }

    console.log(body)


    this.generic_service.updateAssetAuditInfo_Asset(body).subscribe(
      (response:any)=>{
        console.log(response);
        document.getElementById("closeModalView")?.click()

        this.getAllAssetAuditInfoByFinancialYear()
        this.toastr.success(response.message);
      },
      (error:any)=>{
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
      }
    )


  }

  verifyClick(){
    this.isVerify = true
  }

  Verify(){
    console.log(this.assetAuditInfoList)

    for(let list of this.assetAuditInfoList){
      if(list.audited == true){
     let body = {
        "version": 0,
        "isActive": true,
        "description": "",
        "updatedData": {
          "version": 0,
          "isActive": true,
          "description": list.description,
          "assetId": list.assetId,
          "assetName": list.assetName,
          "assetPurchaseValue": list.assetPurchaseValue,
          "assetCurrentEstimatedValue": list.assetCurrentEstimatedValue,
          "assetCondition": list.assetCondition,
          "assetVerificationOn": formatDate(new Date(), 'dd-MM-yyyy', 'en-US'),
          "assetVerificationByUser": this.userCred.userName,
          "assetVerificationByUserQualification": list.assetVerificationByUserQualification,
          "assetVerificationByCompany": list.assetVerificationByCompany,
          "assetOldImages": list.assetOldImages,
          "remarks": list.remarks,
          "assetCurrentImages": list.assetCurrentImages,
          "audited": true,
        },
        "cid": this.cid,
        "assetAuditInfoId": list.assetAuditInfoId
      }

      console.log(body)


      this.generic_service.updateAssetAuditInfo_Asset(body).subscribe(
        (response:any)=>{
          console.log(response);

          this.getAllAssetAuditInfoByFinancialYear()
          // this.toastr.success(response.message);
        },
        (error:any)=>{
          this.toastr.error(error.error.errors[0].description);
          console.log(error)
        }
      )
      }
 
    }


  }


  addAssetImageBtn(){
    document.getElementById("add-assetImage-btn")?.click()
  }

  onAssetChange(event: any) {
    this.file = event.target.files[0];

    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];

    if (!validTypes.includes(this.file.type)) {
      this.toastr.error('Only .png, .jpg, and .jpeg files are allowed.')
      return;
    }

    this.onAssetUpload()
  }

  onAssetUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.assetCurrentImages.push(event.response)
    });
  }

  getAssetAudit(){

  }

}
